export default __webpack_public_path__ + "static/media/Construcción-vías-terciarias.2f4300e1.png";